import React from 'react'
import { FormDisplayErrors } from '@myxplor/forms'
import { listOfCareHours, totalTimeForDay, timeFormatted } from './helpers'

export const hoursAvailableForWeek = (week = {}) => {
  let output = []
  for (const day in week) {
    if (week.hasOwnProperty(day)) {
      output.push(week[day])
    }
  }

  return output.reduce((a, b) => a + b, 0)
}

const hoursClaimedForWeek = (days = {}) => {
  let output = []
  for (const day in days) {
    if (days.hasOwnProperty(day)) {
      output.push(totalTimeForDay(days[day]))
    }
  }

  return output.reduce((a, b) => a + b, 0)
}

const WeekOvertime = ({ issCase, values }) => {
  const hoursAvailable = hoursAvailableForWeek(listOfCareHours(issCase, values.payment_type))
  const hoursClaimed = hoursClaimedForWeek(values.days)

  if (hoursClaimed <= hoursAvailable) {
    return null
  }

  return (
    <FormDisplayErrors
      errors={`You are attempting to claim ${timeFormatted(
        hoursClaimed
      )} for this week, but you are only allowed a total of ${timeFormatted(hoursAvailable)}`}
    />
  )
}

export default WeekOvertime



// WEBPACK FOOTER //
// ./src/iss-case-claims/details/case-claim/form/week-overtime.jsx